import Vue from 'vue';
import Router from 'vue-router';
import Customers from '@/components/Customers';
import CreateCustomer from '@/components/CreateCustomer';
import Customer from '@/components/Customer';
import Facilities from '@/components/Facilities';
import Facility from '@/components/Facility';
import FacilityForm from '@/components/FacilityForm';
import FacilityTodos from '@/components/FacilityTodos';
import Profile from '@/components/Profile';
import NewSiteUnitType from '@/components/NewSiteUnitType';
import SiteMap from '@/components/SiteMap';
import FacilityScene from '@/components/FacilityScene';
import NoSiteMap from '@/components/NoSiteMap';
import Units from '@/components/Units';
import Users from '@/components/Users';
import UserForm from '@/components/UserForm';
import Leasing from '@/components/Leasing';
import Lease from '@/components/Lease';
import Unit from '@/components/Unit';
import Org from '@/components/OrgPage';
import OrgPricing from '@/components/OrgPricing';
import DashboardPage from '@/components/DashboardPage';
import CommunicationPage from '@/components/CommunicationPage';
import Finance from '@/components/Finance';
import Audit from '@/components/AuditView';
import FinanceDeposits from '@/components/FinanceDeposits';
import FinanceBalanceSheet from '@/components/FinanceBalanceSheet';
import FinanceFacility from '@/components/FinanceFacility';
import FinanceCollections from '@/components/FinanceCollections';
import FinanceSalesTax from '@/components/FinanceSalesTax';
import FinanceAccrual from '@/components/FinanceAccrual';
import FinanceMove from '@/components/FinanceMove';
import GlobalAvailability from '@/components/GlobalAvailability';
import FacilityPayments from '@/components/FacilityPayments';
import FacilityTransaction from '@/components/FacilityTransaction';
import Risks from '@/components/Risks';
import FacilityAudit from '@/components/FacilityAudit';
import AuditCommercial from '@/components/AuditCommercial';
import AuditCredits from '@/components/AuditCredits';
import AuditVoid from '@/components/AuditVoid';
import AuditTransactions from '@/components/AuditTransactions';
import AuditRefundRequests from '@/components/AuditRefundRequests';
import AuditCCFW from '@/components/AuditCCFW';
import GlobalUnitVacancy from '@/components/GlobalUnitVacancy';
import CustomerWalletTransaction from '@/components/CustomerWalletTransaction';
import WalletDetail from '@/components/WalletDetail';
import FacilityOccupancyReport from '@/components/FacilityOccupancyReport';

Vue.use(Router);

export default function setupRouter() {
  const router = new Router({
    routes: [
      {
        path: '/404/error',
        name: 'Not found',
        component: NoSiteMap,
        props: {
          description: '404 Not Found!',
        },
      },
      {
        path: '/',
        redirect: '/dashboard',
        props: true,
      },
      {
        path: '/sitemap',
        name: 'Sitemap',
        component: NoSiteMap,
      },
      {
        path: '/sitemap/:facility',
        name: 'Facility Sitemap',
        component: FacilityScene,
        props: true,
      },
      {
        path: '/sitemap-legacy/:facility',
        name: 'Facility Sitemap Legacy',
        component: SiteMap,
        props: true,
      },
      {
        path: '/units',
        name: 'Units',
        component: NoSiteMap,
      },
      {
        path: '/units/:facility',
        name: 'Facility Units',
        component: Units,
        props: true,
      },
      {
        path: '/units/:facility/:unit',
        name: 'Facility Unit',
        component: Unit,
        props: true,
      },
      {
        path: '/customers/:facility',
        name: 'Facility Customers',
        component: Customers,
        props: true,
      },
      {
        path: '/customers',
        name: 'Customers',
        component: Customers,
        props: true,
      },
      {
        path: '/createCustomer',
        name: 'Create Customer',
        component: CreateCustomer,
      },
      {
        path: '/createCustomer/:facility',
        name: 'Facility Create Customer',
        component: CreateCustomer,
        props: true,
      },
      {
        path: '/customers/customer/:id/:facility',
        name: 'Facility Customer',
        component: Customer,
        props: true,
      },
      {
        path: '/customers/customer/:customer/:facility/:id',
        name: 'Facility Customer Payment',
        component: CustomerWalletTransaction,
        props: true,
      },
      {
        path: '/customers/customer/:id',
        name: 'Customer',
        component: NoSiteMap,
        props: true,
      },
      {
        path: '/customers/:customerId/:facility/edit',
        name: 'Facility Customer Edit',
        component: CreateCustomer,
        props: true,
      },
      {
        path: '/customers/:customerId/edit',
        name: 'Customer Edit',
        component: CreateCustomer,
        props: true,
      },
      {
        path: '/facilities',
        name: 'Facilities',
        component: Facilities,
        props: true,
      },
      {
        path: '/facilities/:facility',
        name: 'Facility',
        component: Facility,
        props: true,
      },
      {
        path: '/facilities/:facility/edit',
        name: 'Facility Edit',
        component: FacilityForm,
        props: true,
      },
      {
        path: '/facilities/create',
        name: 'Facility Create',
        component: FacilityForm,
        props: true,
      },
      {
        path: '/units/type/create',
        name: 'Create Site Unit',
        component: NewSiteUnitType,
      },
      {
        path: '/settings/profile',
        name: 'Manager Profile',
        component: Profile,
        props: true,
        children: [
          {
            path: '/settings/profile/:facility',
            name: 'Facility Manager Profile',
            component: Profile,
            props: true,
          },
        ],
      },
      {
        path: '/comms',
        name: 'Communication',
        component: NoSiteMap,
      },
      {
        path: '/comms/:facility',
        name: 'Facility Communication',
        component: CommunicationPage,
        props: true,
      },
      {
        path: '/audit',
        name: 'Audit',
        component: Audit,
        children: [
          {
            path: '/audit/commercial',
            name: 'Audit commercial',
            component: Audit,
            props: true,
            children: [
              {
                path: '/audit/commercial/:facility',
                name: 'Facility Audit commercial',
                component: AuditCommercial,
                props: true,
              },
            ]
          },
          {
            path: '/audit/:facility',
            name: 'Facility Audit',
            component: FacilityAudit,
            props: true,
          },
          {
            path: '/audit/credits',
            name: 'Audit credits',
            component: Audit,
            props: true,
            children: [
              {
                path: '/audit/credits/:facility',
                name: 'Facility Audit credits',
                component: AuditCredits,
                props: true,
              },
            ],
          },
          {
            path: '/audit/transactions',
            name: 'Audit transactions',
            component: Audit,
            props: true,
            children: [
              {
                path: '/audit/transactions/:facility',
                name: 'Facility Audit transactions',
                component: AuditTransactions,
                props: true,
              },
            ],
          },
          {
            path: 'audit/void',
            name: 'Audit void',
            component: Audit,
            props: true,
            children: [
              {
                path: '/audit/void/:facility',
                name: 'Facility Audit void',
                component: AuditVoid,
                props: true,
              },
            ],
          },
          {
            path: 'audit/ccfw',
            name: 'Audit ccfw',
            component: Audit,
            props: true,
            children: [
              {
                path: '/audit/ccwf/:facility',
                name: 'Facility Audit ccfw',
                component: AuditCCFW,
                props: true,
              },
            ],
          },
          {
            path: 'audit/refunds',
            name: 'Audit refunds',
            component: Audit,
            props: true,
            children: [
              {
                path: '/audit/refunds/:facility',
                name: 'Facility Audit refunds',
                component: AuditRefundRequests,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: NoSiteMap,
        props: true,
      },
      {
        path: '/dashboard/:facility',
        name: 'Facility Dashboard',
        component: DashboardPage,
        props: true,
      },
      {
        path: '/leasing',
        name: 'Leasing',
        component: NoSiteMap,
      },
      {
        path: '/leasing/:facility',
        name: 'Facility Leasing',
        component: Leasing,
        props: true,
      },
      {
        path: '/leasing/:facility/:id',
        name: 'Facility Leasing Item',
        component: Lease,
        props: true,
      },
      {
        path: '/occupancy',
        name: 'Occupancy',
        component: NoSiteMap,
        props: true,
      },
      {
        path: '/occupancy/:facility',
        name: 'Facility Occupancy',
        component: FacilityOccupancyReport,
        props: true,
      },
      {
        path: '/risks',
        name: 'Risks',
        component: NoSiteMap,
      },
      {
        path: '/risks/:facility',
        name: 'Facility Risks',
        component: Risks,
        props: true,
      },
      {
        path: '/users',
        name: 'Users',
        component: Users,
      },
      {
        path: '/users/:facility',
        name: 'Facility Users',
        component: Users,
        props: true,
      },
      {
        path: '/users/user/new',
        name: 'User Form',
        component: UserForm,
      },
      {
        path: '/users/:facility/user/new',
        name: 'Facility User Form',
        component: UserForm,
        props: true,
      },
      {
        path: '/todo',
        name: 'Todo',
        component: NoSiteMap,
        props: {
          description: 'Coming soon...',
        },
      },
      {
        path: '/todo/:facility',
        name: 'Facility Todo',
        component: FacilityTodos,
        props: true,
      },
      {
        path: '/config',
        name: 'Config',
        component: Org,
        props: true,
      },
      {
        path: '/config/:facility',
        name: 'Facility Config',
        component: Org,
        props: true,
      },
      {
        path: '/pricing',
        name: 'Pricing',
        component: NoSiteMap,
        props: true,
      },
      {
        path: '/pricing/:facility',
        name: 'Facility Pricing',
        component: OrgPricing,
        props: true,
      },
      {
        path: '/payments',
        name: 'Payments',
        component: NoSiteMap,
        props: true,
      },
      {
        path: '/payments/:facility',
        name: 'Facility Payments',
        component: FacilityPayments,
        props: true,
      },
      {
        path: '/payments/:facility/:id',
        name: 'Facility Payments Transaction',
        component: FacilityTransaction,
        props: true,
      },
      {
        path: '/availability',
        name: 'Availability',
        component: GlobalAvailability,
      },
      {
        path: '/unit/vacancy/aging',
        name: 'Finance Vacancy Aging',
        component: GlobalUnitVacancy,
      },
      {
        path: '/unit/vacancy/aging/:facility',
        name: 'Facility Finance Vacancy Aging',
        redirect: () => ({ path: '/unit/vacancy/aging' })
      },
      {
        path: '/availability/:facility',
        name: 'Availability Config',
        redirect: () => ({ path: '/availability' })
      },
      {
        path: '/finance',
        name: 'Finance',
        component: Finance,
        children: [
          {
            path: '/finance/home/:facility',
            name: 'Facility Finance',
            component: FinanceFacility,
            props: true,
          },
        ],
      },
      {
        path: '/finance/balancesheet',
        name: 'Finance Balance Sheet',
        component: Finance,
        children: [
          {
            path: '/finance/balancesheet/:facility',
            name: 'Facility Finance Balance Sheet',
            component: FinanceBalanceSheet,
            props: true,
          },
        ],
      },
      {
        path: '/finance/collections',
        name: 'Finance collections',
        component: Finance,
        children: [
          {
            path: '/finance/collections/:facility',
            name: 'Facility Finance collections',
            component: FinanceCollections,
            props: true,
          },
        ],
      },
      {
        path: '/finance/report',
        name: 'Finance report',
        component: Finance,
        props: true,
        children: [
          {
            path: '/finance/report/:facility',
            name: 'Facility Finance report',
            component: FinanceAccrual,
            props: true,
          },
        ],
      },
      {
        path: '/finance/revision',
        name: 'Finance revision',
        component: Finance,
        props: true,
        children: [
          {
            path: '/finance/revision/:facility',
            name: 'Facility Finance revision',
            component: WalletDetail,
            props: true,
          },
        ],
      },
      {
        path: '/finance/deposits',
        name: 'Finance deposits',
        component: Finance,
        props: true,
        children: [
          {
            path: '/finance/deposits/:facility',
            name: 'Facility Finance deposits',
            component: FinanceDeposits,
            props: true,
          },
        ],
      },
      {
        path: '/finance/sales',
        name: 'Finance sales',
        component: Finance,
        props: true,
        children: [
          {
            path: '/finance/sales/:facility',
            name: 'Facility Finance sales',
            component: FinanceSalesTax,
            props: true,
          },
        ],
      },
      {
        path: '/finance/move',
        name: 'Finance Move in',
        component: Finance,
        props: true,
        children: [
          {
            path: '/finance/move/:facility',
            name: 'Facility Finance Move in',
            component: FinanceMove,
            props: true,
          },
        ],
      },
      {
        path: '*',
        name: '404',
        component: NoSiteMap,
        props: {
          description: '404 Not Found!',
        },
      },
    ],
  });
  return router;
}



// WEBPACK FOOTER //
// ./src/router/index.js